import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      SpaceManagement: 'SpaceManagement',
      docFontSize:'fontSize',
    })
  },
  methods: {
    ...mapMutations({
      
    }),
    ...mapActions({
      getCoverVideo: 'SpaceManagement/getCoverVideo'
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/Sweep/Mixins.js